import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'pkpFilter' })
export class FilterPipe implements PipeTransform {
    transform(
        value: any[],
        options: {
            active: boolean;
            filters: { [column: string]: string };
        }
    ): any[] {
        if (!options.active) {
            return value;
        }
        let result = value.slice();
        for (let key of Object.keys(options.filters)) {
            if (options.filters[key] && options.filters[key].length > 0) {
                result = result.filter((val) => {
                    return (
                        this.getFieldValue(val, key)
                            .toLowerCase()
                            .indexOf(options.filters[key].toLowerCase()) >= 0
                    );
                });
            }
        }
        return result;
    }

    private getFieldValue(object: any, accessor: string) {
        const path = accessor.split('.');
        let obj = object;
        for (let i = 0; i < path.length; i++) {
            if (obj[path[i]]) {
                obj = obj[path[i]];
            } else {
                return null;
            }
        }
        return obj;
    }
}
